import React,{useEffect, useState, useContext} from "react";
import {useParams, useLocation, useNavigate } from "react-router-dom";
import FetchUtil from "../../utils/FetchUtil";
import { useTranslation } from 'react-i18next';
import Sources from "../Common/Sources";
import ProductUses from "./ProductUses";
import FoodProductCodes from "./FoodProductCodes";
import StandardsGrades from "./StandardsGrades";
import ProcessingSupplyChain from "./ProcessingSupplyChain";
import FoodSafetyDefense from "./FoodSafetyDefense";
import ConsumptionTrade from "./ConsumptionTrade";
import LeftMenu from './LeftMenu';
import UserContext from "../../contexts/UserContext";

let foodId = 0;
let foodAnswerKeyVal = {};
let foods = [];	
function FoodDetails() {
	const navigate = useNavigate();
	const { t } = useTranslation();
	const [error, setError] = useState(null);
	const [foodName, setFoodName] = useState('');
	let params = useParams();
	const [slug, setSlug] = useState(params.foodSlug);
	const [answerKeyValues, setAnswerKeyValues] = useState({});
	const [sourceList, setSourceList] = useState([]);
	const userCtx = useContext(UserContext);
	let canRead = false;
	if(userCtx){
		canRead = userCtx.isSubscriptionValid;
	}
	
	const { hash } = useLocation();
	
	useEffect(() => {
		/*fetchFoods();*/
	}, []);
	
	useEffect(() => {
		if(slug){
			//console.log("anchor tag "+hash);
			if(!hash){
				window.scrollTo(10, 0);
			}
			setFoodDetails(slug);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [slug]);
	
	function setFoodDetails(selectedSlug) {
		if (foods && foods.length > 0) {
			foods.map((food, index) => {
				if (food.slug === selectedSlug) {
					foodId = food.foodId;
					setFoodName(food.foodName);
					return;
				}
			});
			fetchFoodAnswers(foodId);
		} else {
			fetchFoods();
		}
	}
	function fetchFoods() {
	    const requestOptions = {
	      credentials: "same-origin",
	      method: "POST",
	      headers: { "Content-Type": "application/json" },
	      body: JSON.stringify({ source: "web"}),
	    };
	    try{
		   FetchUtil.fetchAPI("GetFoods","/Service/StaticHelper/GetFoods", requestOptions, getFoodsSuccess, getFoodsFail);
		} catch (error) {
		   setError(error.message);
		}
	}
  
  	function getFoodsFail(redirect){
  	  setError(t("error.getFoodFailed"));
  	}
  
  	function getFoodsSuccess(responseData){
	  	var foodsResponse;
	  	foods = [];
	  	foodId = 0;
	  	if (responseData) {
	    	foodsResponse = responseData.getFoodsResponse;
	     	if (foodsResponse && foodsResponse.errorCode === "0") {
				foods = foodsResponse.foods.slice();
				if(foods && foods.length > 0){
					foods.map( (food, index) =>{
						if(food.slug === slug){
							foodId = food.foodId;
							setFoodName(food.foodName);
							return;
						}
					});
					fetchFoodAnswers(foodId);
				}
	      	} else if (foodsResponse){
		    	setError(t("error.error") + " " +foodsResponse.errorMessage);
	      	}
	 	 }
	}
	function fetchFoodAnswers(foodId) {
		//console.log(foodId);
	    const requestOptions = {
	      credentials: "same-origin",
	      method: "POST",
	      headers: { "Content-Type": "application/json" },
	      body: JSON.stringify({ source: "web", foodId: foodId}),
	    };
	    try{
		   FetchUtil.fetchAPI("GetFoodAnswers","/Service/StaticHelper/GetFoodAnswers", requestOptions, getFoodAnswersSuccess, getFoodAnswersFail);
		} catch (error) {
		   setError(error.message);
		}
	}
  
  	function getFoodAnswersFail(redirect){
  	  setError(t("error.getFoodAnswersFailed"));
  	}
  
  	function getFoodAnswersSuccess(responseData){
	  	var foodAnswersResponse;
	  	if (responseData) {
	    	foodAnswersResponse = responseData.getFoodAnswerResponse;
	     	if (foodAnswersResponse && foodAnswersResponse.errorCode === "0") {
				setSourceList([...sourceList, ...foodAnswersResponse.foodInfo.sourceList]);
				mapAnswers(foodAnswersResponse.foodInfo.foodAnswers);
	      	} else if (foodAnswersResponse && foodAnswersResponse.errorCode === "10") {
                // access is not there for the user, so logout
                logoffUser();
                navigate("/home");
	      	} else if (foodAnswersResponse){
		    	setError(t("error.error") + " " +foodAnswersResponse.errorMessage);
	      	}
	 	 }
	}
	function mapAnswers(foodAnswers){
		foodAnswerKeyVal = {};
		foodAnswers.map( (foodAnswer) =>{
				foodAnswerKeyVal[foodAnswer.key] = foodAnswer.text;
				foodAnswerKeyVal[foodAnswer.key+"_sources"] = foodAnswer.sourceId;
				foodAnswerKeyVal["food_slug"] = slug;
		})
		setAnswerKeyValues({...foodAnswerKeyVal});
	}
	
	function logoffUser(){
		userCtx.addUserName("");
		userCtx.addLoggedInUserId("");
		userCtx.addRole("");
		userCtx.addIsAuthenticated(false);
		userCtx.addIsSubscriptionValid(false);
		userCtx.addLang("");
		userCtx.addTosTimeStamp("");
		userCtx.addEnabledMFA(0);
		userCtx.clearStorage();
	}
	function isNotEmpty(obj) {
       return Object.keys(obj).length > 0;
    }
  	return (
		<div id="page">
		 {(error) && (
	        <div id="inerrorMessage" className="alert.alert-danger">
	          {error}
	        </div>
	      )}
	        <div className="page-inner">
	      	<div className="output-main">
	      		 <div className="row">
         			<div className="col-3">
         			{(foodId > 0 && isNotEmpty(answerKeyValues) )? 
         			<LeftMenu canRead={canRead} foodAnswers={{answerKeyValues}} foodList={foods} defaultFoodId={foodId}/>
         			: ""}
         			</div>
         			<div className="col-9">
         				<div className="clearfix" style={{marginBottom: "20px"}}>
							<div className="pull-left">
								<h1>{foodName}</h1>
								<ProductUses foodAnswers={{answerKeyValues}} />
								<FoodProductCodes foodAnswers={{answerKeyValues}} />
								<StandardsGrades foodAnswers={{answerKeyValues}} foodName={foodName} />
								<ConsumptionTrade foodAnswers={{answerKeyValues}} foodName={foodName} />
								<ProcessingSupplyChain foodAnswers={{answerKeyValues}} />
								<FoodSafetyDefense foodAnswers={{answerKeyValues}} />
								<Sources sourceList={{sourceList}} />
							</div>
						</div>
         			</div>
         		</div>
	      	</div>
	      </div>
        </div>
  );
}
export default FoodDetails;
